import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

export const OfferCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  margin: theme.spacing(1, 0),
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
  '& .itemCon': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '33%',
    height: 400,
    alignItems: 'center',
    background: colors.white,
    borderRadius: 6,
    margin: theme.spacing(1, 0.5),
    [theme.breakpoints.between('sm', 'md')]: {
      height: 320,
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      height: 320,
      width: '33%',
      margin: theme.spacing(1, 0),
    },
    [theme.breakpoints.down('xs')]: {
      height: 250,
      width: '100%',
      margin: theme.spacing(1),
    },
    '& img': {
      margin: theme.spacing(2, 0),
      width: 100,
      height: 'auto',
      borderRadius: 8,
      [theme.breakpoints.between('xs', 'md')]: {
        margin: theme.spacing(1, 0),
        width: '60%',
      },
      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(0.5, 0),
        width: '30%',
      },
    },
    '& .subText': {
      fontSize: fontSizes.medium,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        textAlign: 'center',
        margin: theme.spacing(0, 1),
      },
    },
  },
}))
